<template>
<div v-on:click="$emit('click')">
	<i v-if="calcIndexFromMoment(eventItem.startMoment,selectedDate) < 0"
		class="fa fa-chevron-left mr-1"></i>
	<i class="fa fa-fw" :class="typeIcon(eventItem.type)" :style="{
		'color' : itemColor
	}"></i>
	<i v-if="eventItem.type == 'user'" class="fa-fw ml-1 mr-1" :class="{
			'fa-umbrella-beach fas' : eventItem.is_vacation == 1,
			'fa-first-aid fa': eventItem.is_sickday == 1,
			'fa-ban fas' : eventItem.is_off == 1,
			'fa-wrench' : eventItem.type == 'equipment-servicing'
		}"></i>
	<i v-if="isManagementLead" class="fa fa-fw fa-user-tie" title="Is management lead"></i>
	<i v-if="isOpsLead" class="fas fa-fw fa-hard-hat" title="Is operations lead"></i>
	<i v-if="eventItem.isLeadTechnician" class="fa fa-fw fa-vest" title="Is lead crew member"></i>
	<i v-if="eventItem.notes" class="fa fa-fw fa-sticky-note text-info"></i>
	<span v-if="eventItem.is_off == 1">OFF:</span>
	<span v-if="eventItem.is_vacation == 1 && !eventItem.ApprovedBy" class="text-light bg-warning mr-1">
		PENDING
	</span>
	<span v-if="'userRole' in eventItem && eventItem.userRole">
		{{eventItem.userRole.abbreviation}}
	</span>
</div>
</template>
<script type="text/javascript">

import ScheduleMixins from "@/mixins/ScheduleMixins.js"

export default {
	name: "ScheduleCardIndicators",
	props: [
		"eventItem",
		"selectedDate"
	],
	mixins: [ScheduleMixins],
	computed: {
		isManagementLead() {
			return this.getItemRoleKeyValue("is_management_lead")
		},
		isOpsLead() {
			return this.getItemRoleKeyValue("is_field_ops_lead")
		},
		itemColor() {
			//employee takes precedence over classification
			if (this.eventItem.type == "user") {
			
				if  ("User" in this.eventItem && this.eventItem.User) {
					if ("EmployeeSetting" in this.eventItem.User && this.eventItem.User.EmployeeSetting && this.eventItem.User.EmployeeSetting.length > 0 &&
						"color_hex" in this.eventItem.User.EmployeeSetting[0] && this.eventItem.User.EmployeeSetting[0].color_hex)
						
						return this.eventItem.User.EmployeeSetting[0].color_hex
					else if ("EmployeeClassification" in this.eventItem.User && this.eventItem.User.EmployeeClassification && this.eventItem.User.EmployeeClassification.length > 0 &&
							 "color_hex" in this.eventItem.User.EmployeeClassification[0] && this.eventItem.User.EmployeeClassification[0].color_hex)

						return this.eventItem.User.EmployeeClassification[0].color_hex
				}
			}
			else if (this.eventItem.type == 'equipment-servicing' || this.eventItem.type == 'equipment') {
				if ("Equipment" in this.eventItem && this.eventItem.Equipment) {
					if ("color_hex" in this.eventItem.Equipment && this.eventItem.Equipment.color_hex)
						return this.eventItem.Equipment.color_hex
					else if ("EquipmentType" in this.eventItem.Equipment && this.eventItem.Equipment.EquipmentType) {
						if ("color_hex" in this.eventItem.Equipment.EquipmentType && this.eventItem.Equipment.EquipmentType.color_hex)
							return this.eventItem.Equipment.EquipmentType.color_hex
						else if ("EquipmentCategory" in this.eventItem.Equipment.EquipmentType &&this.eventItem.Equipment.EquipmentType.EquipmentCategory && 
								 "color_hex" in this.eventItem.Equipment.EquipmentType.EquipmentCategory && this.eventItem.Equipment.EquipmentType.EquipmentCategory.color_hex)
							return this.eventItem.Equipment.EquipmentType.EquipmentCategory.color_hex
					}
				}
			}
			
			return "black"
		}
	},
	methods: {
		getItemRoleKeyValue(key) {
			let job = false
			if (this.eventItem.type == 'user' && "Job" in this.eventItem && this.eventItem.Job)
				job = this.eventItem.Job
			else if (this.eventItem.type == 'user' && "Service" in this.eventItem && this.eventItem.Service)
				job = this.eventItem.Service

			if (job && "JobPersonnelRole" in job && job.JobPersonnelRole)
				return job.JobPersonnelRole
					.find(role => role[key] == 1 && role.user_id == this.eventItem.User.id) ? true : false

			return false
		}
	}
}
</script>

